<app-search-grid
  i18n-header
  header="Roles"
  [service]="roleService"
  [columnDefs]="columnDefs"
  [allowNavigateOnSingleResult]="false"
></app-search-grid>
